import type { IContactPersonDetails } from './ContactPersonDetails.interface';
import { epoch, utc } from '../../util/datetime';
import Address from '../address/Address';
import ContactPreferredContactMethod from './ContactPreferredContactMethod';
import { ContactResidentialStatusOption } from './ContactResidentialStatusOption.enum';

export default class ContactPersonDetails implements IContactPersonDetails {
  primaryCode: string;
  primary: string;
  homeCode: string;
  home: string;
  workCode: string;
  work: string;
  email: string;
  secondaryEmail: string;
  website: string;
  preferredContactMethod: ContactPreferredContactMethod;
  address: Address;
  housing: ContactResidentialStatusOption;
  from: number;
  previousAddress: Address;
  previousHousing: ContactResidentialStatusOption;
  previousFrom: number;
  mailingAddress: Address;
  settlementHousing: ContactResidentialStatusOption;
  settlementAddress: Address;

  static build = (data: IContactPersonDetails) => new ContactPersonDetails(data);
  static blank = () => new ContactPersonDetails();

  /**
   * Constructor
   * @param {ContactPersonDetails} data
   */
  constructor(data?: IContactPersonDetails) {
    this.primaryCode = data?.primaryCode || '';
    this.primary = data?.primary || '';
    this.homeCode = data?.homeCode || '';
    this.home = data?.home || '';
    this.workCode = data?.workCode || '';
    this.work = data?.work || '';
    this.email = data?.email || '';
    this.secondaryEmail = data?.secondaryEmail || '';
    this.website = data?.website || '';
    this.preferredContactMethod = new ContactPreferredContactMethod(
      data?.preferredContactMethod
    );
    this.address = new Address(data?.address);
    this.housing = ContactResidentialStatusOption.of(
      data?.housing?.name || data?.housing?.toString()
    );
    this.from = data?.from ? epoch(utc(data?.from)) : 0;
    this.previousAddress = new Address(data?.previousAddress);
    this.previousHousing = ContactResidentialStatusOption.of(
      data?.previousHousing?.name || data?.previousHousing?.toString()
    );
    this.previousFrom = data?.previousFrom ? epoch(utc(data?.previousFrom)) : 0;
    this.mailingAddress = new Address(data?.mailingAddress);
    this.settlementHousing = ContactResidentialStatusOption.of(
      data?.settlementHousing?.name || data?.settlementHousing?.toString()
    );
    this.settlementAddress = new Address(data?.settlementAddress);
  }
}
